import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { injectIntl } from 'react-intl';
import getTranslatedText from '../../services/getTranslatedText';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import ArrowDropRight from 'material-ui/svg-icons/navigation-arrow-drop-right';

const styles = {
  selectQuestionButtonLabel: {
    textTransform: 'none',
    fontSize: 16,
  },
};

@injectIntl
class QuestionPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questionSelectorOpen: false,
    };
  }

  showQuestionSelector = (event) => {
    this.setState({
      questionSelectorOpen: true,
      anchorEl: event.currentTarget,
    });
  };

  hideQuestionSelector = () => {
    this.setState({
      questionSelectorOpen: false,
    });
  };

  updateQuestion = (questionMongoId) => {
    this.setState({
      questionSelectorOpen: false,
    });
    this.props.onChange(questionMongoId);
  };

  render() {
    const surveyEdges = (this.props.surveys && this.props.surveys.edges) || [];
    const surveyNodes = surveyEdges.map(edge => edge.node);
    const surveysWithQuestions = surveyNodes.map((survey) => {
      const questionEdges = (survey.questions && survey.questions.edges) || [];
      const questionNodes = questionEdges.map(edge => edge.node);
      const questions = questionNodes.map((question) => {
        const text = getTranslatedText(question.text, this.props.intl.locale);
        return Object.assign({}, question, { text });
      });
      return Object.assign({}, survey, { questions });
    });

    let selectQuestionButtonLabel = this.props.label || 'Choose question';
    if (this.props.selectedQuestion) {
      surveysWithQuestions.forEach((survey) => {
        survey.questions.forEach((question) => {
          if (this.props.selectedQuestion === question.mongoId) {
            selectQuestionButtonLabel = question.text + ' (' + question.type + ')';
          }
        });
      });
    }

    return (
      <div style={this.props.wrapperStyles}>
        <RaisedButton
          onClick={this.showQuestionSelector}
          label={selectQuestionButtonLabel}
          labelStyle={styles.selectQuestionButtonLabel}
        />
        <Popover
          open={this.state.questionSelectorOpen}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
          targetOrigin={{ horizontal: 'left', vertical: 'top' }}
          onRequestClose={this.hideQuestionSelector}
        >
          <Menu>
            {surveysWithQuestions.map(survey =>
              <MenuItem
                key={survey.id}
                primaryText={getTranslatedText(survey.name, this.props.intl.locale)}
                rightIcon={<ArrowDropRight />}
                menuItems={survey.questions.map((question) => {
                  return (
                    <MenuItem
                      key={question.id}
                      value={question.id}
                      primaryText={
                        question.text
                        + ' ('
                        + question.type
                        + ', ...'
                        + question.mongoId.substr(question.mongoId.length - 4)
                        + ')'
                      }
                      onClick={() => this.updateQuestion(question.mongoId)}
                    />
                  );
                })}
              />
            )}
          </Menu>
        </Popover>
      </div>
    );
  }
}

export default createFragmentContainer(
  QuestionPicker,
  graphql`
    fragment QuestionPicker_surveys on SurveyConnection {
      edges {
        node {
          id
          name {
            text
            language
          }
          questions {
            edges {
              node {
                id
                mongoId
                type
                text {
                  language
                  text
                }
              }
            }
          }
        }
      }
    }
  `,
);



// WEBPACK FOOTER //
// ./src/components/QuestionPicker/QuestionPicker.js